// Defensafe API client.
// In dev (CRA on :3000) point to a separate PHP host via REACT_APP_API_BASE.
// In prod (same Apache host), API_BASE is relative ('/api').

const API_BASE = process.env.REACT_APP_API_BASE || '/api';

let csrfToken = null;
export const setCsrf = (t) => { csrfToken = t; };
export const getCsrf = () => csrfToken;

async function request(path, { method = 'GET', body, query } = {}) {
  const qs = query ? '?' + new URLSearchParams(query).toString() : '';
  const opts = {
    method,
    credentials: 'include',
    headers: { 'Accept': 'application/json' },
  };
  if (body !== undefined) {
    opts.headers['Content-Type'] = 'application/json';
    opts.body = JSON.stringify(body);
  }
  if (csrfToken && method !== 'GET') opts.headers['X-CSRF-Token'] = csrfToken;
  const res = await fetch(`${API_BASE}${path}${qs}`, opts);
  let data = null;
  try { data = await res.json(); } catch (_) {}
  if (!res.ok) {
    const err = new Error(data?.error || `HTTP ${res.status}`);
    err.status = res.status; err.data = data;
    throw err;
  }
  return data;
}

export const api = {
  me:     () => request('/auth.php', { query: { action: 'me' } }),
  login:  ({ username, password, actor }) => request('/auth.php', { method: 'POST', query: { action: 'login' }, body: { username, password, actor } }),
  logout: () => request('/auth.php', { method: 'POST', query: { action: 'logout' } }),

  resolveUrl: (url) => request('/resolve.php', { query: { url } }),
  importRows: (payload) => request('/import.php', { method: 'POST', body: payload }),
  listUsers:  () => request('/users.php'),
  createUser: (u) => request('/users.php', { method: 'POST', body: u }),
  updateUser: (u) => request('/users.php', { method: 'PUT', body: u }),
  deleteUser: (id) => request('/users.php', { method: 'DELETE', query: { id } }),

  listLocations: () => request('/locations.php'),
  createLocation: (loc) => request('/locations.php', { method: 'POST', body: loc }),
  updateLocation: (loc) => request('/locations.php', { method: 'PUT', body: loc }),
  deleteLocation: (id, note) => request('/locations.php', { method: 'DELETE', query: { id, ...(note ? { note } : {}) } }),

  history: (locationId) => request('/history.php', { query: locationId ? { location_id: locationId } : {} }),
  resetHistory: (note) => request('/history.php', { method: 'POST', query: { action: 'reset' }, body: { note } }),

  backups:        () => request('/backups.php'),
  createBackup:   (reason) => request('/backups.php', { method: 'POST', query: { action: 'create' }, body: { reason } }),
  restoreBackup:  (name, note) => request('/backups.php', { method: 'POST', query: { action: 'restore' }, body: { name, note } }),
  deleteBackup:   (name) => request('/backups.php', { method: 'DELETE', query: { name } }),
};
